// AIGenerateComponent.vue (nouvelle version intégrant le Wizard)
<template>
  <div class="ai-generate-wrapper">
    <h3>🧠 Generate elements using AI</h3>
    <div class="alert alert-info">
      You can either use a connected API (e.g., LM Studio, ChatGPT) or manually copy-paste prompts into an online LLM-chatbot.
    </div>

    <!-- Intégration directe du wizard -->
    <AIGeneratorWizard
      :context="context"
      :test-id="testId"
      @submit="handleAIItems"
      @confirm="handleConfirm"
    />
  </div>
</template>

<script setup>
import AIGeneratorWizard from './AIGeneratorWizard.vue';
import { useTestStore } from '@/stores/testStore';

const props = defineProps({
  context: {
    type: String,
    default: 'default'
  },
  testId: {
    type: String,
    default: ''
  },
  selectedElement: Object,
  prompt: String
});

const emit = defineEmits(['confirm']);

const store = useTestStore();

const handleAIItems = (items) => {
  console.log("✅ Données JSON intégrées par le wizard:", items?.length || 0, "items");
  // Note: En mode conditionnel, tout est déjà géré par AIGeneratorWizard.vue :
  // - Les éléments ont été créés atomiquement via POST /tests/:testId/elements
  // - Les nodes ont été ajoutés à la ConditionalStructure via PUT /tests/:testId/conditional-structure
  // - L'événement 'confirm' a été émis pour notifier le parent (ConditionalTestEditor)
  // Pas besoin d'action supplémentaire ici, le wizard a tout géré.

  // Pour les tests linéaires (mode 'default'), ce handler n'est pas utilisé non plus
  // car le wizard émet directement 'submit' vers TabsComponent qui gère l'ajout des items
};

const handleConfirm = (payload) => {
  console.log('📤 AIGenerateComponent - Propagation confirm vers TabsComponent:', payload);
  // Propager l'événement confirm vers le parent (TabsComponent)
  emit('confirm', payload);
};
</script>

<style scoped>
.ai-generate-wrapper {
  padding: 2rem;
}
</style>
